import React, { useState } from 'react';
import {
  Box,
  Button,
  Input,
  Text,
  VStack,
  Field,
  InputGroup,
  Icon,
  Image,
  Alert,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { useFormik } from 'formik';
import BaseProgressCircle from '../../../../components/BaseProgressCircle';
import AuthCard from '../../components/AuthCard';
import { LOGIN } from "../../../../constants/routes";

export interface ForgotPasswordData {
  email: string;
}

interface ForgotPasswordFormProps {
  onForgotPasswordSubmit: (formData: ForgotPasswordData, setError: (error: string) => void) => Promise<void>;
}

export default function ForgotPasswordForm ({ onForgotPasswordSubmit }: ForgotPasswordFormProps) {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    values,
    handleChange,
    errors,
    touched,
  } = useFormik<ForgotPasswordData>({
    initialValues: {
      email: '',

    },
    onSubmit: async (formData) => {
      setLoading(true);
      await onForgotPasswordSubmit(formData, setError);
      setLoading(false);
    },
  });


  return (
    <AuthCard title="Forgot password" onClose={() => navigate(LOGIN)}>
      <form onSubmit={handleSubmit}>
        <VStack align="stretch" gap={5}>
          <Text color="secondary">
            If you have lost your password, we can help you reset it. To initiate password reset process, please enter your email in the box below and click on the button.
          </Text>

          <VStack gap={4}>
            <Field.Root invalid={touched.email && Boolean(errors.email)}>
              <InputGroup>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  required
                  placeholder='Email'
                  borderRadius={15}
                  size='lg'
                />
              </InputGroup>

              <Field.ErrorText>{errors.email}</Field.ErrorText>
            </Field.Root>
          </VStack>

          <Button 
            colorPalette="brand" 
            type="submit" 
            size='lg' 
            w='260px' 
            borderRadius={15} 
            alignSelf='center'
            // mt={8}
            disabled={loading}
          >
            {loading ? <BaseProgressCircle /> : "Reset Password"}
          </Button>

          {error && (
            <Alert.Root status="error">
              <Alert.Indicator />
              <Alert.Title>{error}</Alert.Title>
            </Alert.Root>
          )}
        </VStack>
      </form>
    </AuthCard>
  );
};
